/**
 * @file: useNavigateToTaskListItem.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import type { AppNavParams } from '@euler/app/Routes';
import type { TaskListItem } from '@euler/model/TaskListItem';
import { useNavigation } from '@react-navigation/native';
import type { StackNavigationProp } from '@react-navigation/stack';
import { useCallback } from 'react';

export const kSubscriptionStatusCached = new Map<string, boolean>();

export const useNavigateToTaskListItem = () => {
  const navigation = useNavigation<StackNavigationProp<AppNavParams>>();
  return useCallback(
    (item: TaskListItem) => {
      if (item.type === 'service-record') {
        navigation.push('ServiceRecord', { id: item.serviceRecordId });
      } else {
        kSubscriptionStatusCached.set(
          `task/${item.taskNo}`,
          item.subscribed ?? false,
        );
        navigation.push('Task', { taskNo: item.taskNo });
      }
    },
    [navigation],
  );
};
